import React, { useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { colors } from '../components/Theme/WebTheme';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TextField, Switch } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";
import { makeStyles } from "@mui/styles";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  textField: {
    "& label.Mui-focused": {
      color: "var(--text-light)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: '#487FFF',
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: '#487FFF',
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: '#487FFF',
      },
      "& fieldset": {
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
    },
    "& input": {
      color: "var(--text-main)",
    },
    "& label": {
      color: '#94a3b8',
    }
  },
  selectField: {
    color: "var(--text-main)",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: '#487FFF',
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
  dateTimePickerInput: {
    '& .MuiOutlinedInput-input': {
      color: "var(--text-main)",
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ffffff',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#487FFF',
    },
  },
}));
export default function Promos() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editPromo
  } = api;
  const settings = useSelector(state => state.settingsdata.settings);

  const inputRef = useRef(null);

  const columns = [
    {
      title: t('promo_name'), field: 'promo_name',
    },
    {
      title: t('promo_code_web'), field: 'promo_code'
    },
    {
      title: t('description'), field: 'promo_description',
    },
    {
      title: t('type'),
      field: 'promo_discount_type',
      lookup: { flat: t('flat'), percentage: t('percentage') },
    },
    {
      title: t('promo_discount_value'), field: 'promo_discount_value', type: 'numeric',
    },
    {
      title: t('max_limit'), field: 'max_promo_discount_value', type: 'numeric',
    },
    {
      title: t('min_limit'), field: 'min_order', type: 'numeric',
    },
    {
      title: t('end_date'), field: 'promo_validity',
      editComponent: props => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            inputRef={inputRef}
            renderInput={(props) => <TextField {...props} variant='outlined' className={classes.dateTimePickerInput} />}
            label="DateTimePicker"
            value={props.rowData.promo_validity ? props.rowData.promo_validity : new Date()}
            onChange={(newValue) => {
              props.onChange(newValue)
            }}
            autoFocus={false}
          />
        </LocalizationProvider>
      ),
      render: rowData => rowData.promo_validity ? moment(rowData.promo_validity).format('lll') : null,
    },
    {
      title: t('promo_usage'), field: 'promo_usage_limit', type: 'numeric',
    },
    {
      title: t('show_in_list'), field: 'promo_show', type: 'boolean', render: (rowData) => (
        <Switch
          checked={rowData.promo_show}
          onChange={() => handelShowPromo(rowData)}
          disabled={!settings.AllowCriticalEditsAdmin}
        />
      ),
    },
    {
      title: t('first_ride_only', 'First Ride Only'), field: 'first_ride_only', type: 'boolean', render: (rowData) => (
        <Switch
          checked={rowData.first_ride_only || false}
          onChange={() => dispatch(editPromo({ ...rowData, first_ride_only: !rowData.first_ride_only }, "Update"))}
          disabled={!settings.AllowCriticalEditsAdmin}
        />
      ),
    },
    {
      title: t('promo_used_by'), field: 'user_avail', editable: 'never',
    }
  ];

  const [data, setData] = useState([]);
  const promodata = useSelector(state => state.promodata);
  const dispatch = useDispatch();
  const [sortedData, SetSortedData] = useState([]);
  const classes = useStyles();

  const navigate = useNavigate();
  const [role, setRole] = useState(null);
  const auth = useSelector(state => state.auth);
  const [selectedRow, setSelectedRow] = useState(null);


  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (promodata.promos) {
      setData(promodata.promos);
    } else {
      setData([]);
    }
  }, [promodata.promos]);

  useEffect(() => {
    if (data) {
      SetSortedData(data.sort((a, b) => (moment(b.createdAt) - moment(a.createdAt))))
    }
  }, [data])

  const handelShowPromo = (rowData) => {

    if (role === "admin") {
      dispatch(editPromo({ ...rowData, promo_show: !rowData.promo_show }, "Update"))
    }
  };
  return (
    promodata.loading ? <CircularLoading /> :
      <div style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh', padding: '24px' }}>
        
        <MaterialTable
          title={t('promo_offer_title')}
          columns={columns}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "20px",
            boxShadow: "var(--shadow)",
            
            padding: "0",
            backgroundColor: "var(--bg-card)",
            backdropFilter: "blur(12px)",
            border: "var(--card-border)",
            overflow: "hidden"
          }}
          data={sortedData}

          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 15, 20],
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? "var(--table-row-selected)" : "var(--table-row-bg)",
              borderBottom: "var(--table-border)",
              fontSize: "14px",
              color: "var(--text-main)"
            }),
            editable: {
              backgroundColor: colors.Header_Text,
              fontSize: "0.8em",
              fontWeight: 'bold ',
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
            headerStyle: {
              position: "sticky",
              top: "0px",
              background: "var(--table-header-bg)",
              color: "var(--text-light)",
              textAlign: "center",
              fontWeight: "700",
              fontFamily: 'Inter, sans-serif',
              border: "none",
              height: "56px",
              borderBottom: "var(--card-border)"
            },
            cellStyle: {
              borderBottom: "var(--table-border)",
              textAlign: "center",
              padding: "14px",
              color: "var(--text-main)"
            },
            actionsColumnIndex: -1,
          }}
          localization={{
            body: {
              addTooltip: (t('add')),
              deleteTooltip: (t('delete')),
              editTooltip: (t('edit')),
              emptyDataSourceMessage: (
                (t('blank_message'))
              ),
              editRow: {
                deleteText: (t('delete_message')),
                cancelTooltip: (t('cancel')),
                saveTooltip: (t('save'))
              },
            },
            toolbar: {
              searchPlaceholder: (t('search')),
              exportTitle: (t('export')),
            },
            header: {
              actions: (t('actions'))
            },
            pagination: {
              labelDisplayedRows: ('{from}-{to} ' + (t('of')) + ' {count}'),
              firstTooltip: (t('first_page_tooltip')),
              previousTooltip: (t('previous_page_tooltip')),
              nextTooltip: (t('next_page_tooltip')),
              lastTooltip: (t('last_page_tooltip'))
            },
          }}
          editable={{

            onRowDelete: oldData =>
              settings.AllowCriticalEditsAdmin ?
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    dispatch(editPromo(oldData, "Delete"));
                  }, 600);
                })
                :
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    alert(t('demo_mode'));
                  }, 600);
                })
          }}
          actions={[
            {
              icon: 'add',
              tooltip: t("add_promo_title"),
              isFreeAction: true,
              onClick: (event) => navigate(`/promos/editpromo`)
            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--text-main)"
                  }}
                >
                  <EditIcon fontSize="small" />
                </div>
              ),
              onClick: (event, rowData) => {
                navigate(`/promos/editpromo/${rowData.id}`)
              }
            }),
          ]}
        />
      </div>
  );
}
